<template>
  <div class="reservations-cta-container">
    <div class="cta-card">
      <!-- Image Column -->
      <div class="cta-image-container">
        <img v-lazy="ctaImage" height="150px" width="150px" alt="VIP table experience at a Tulum jungle party">
      </div>

      <!-- Content Column -->
      <div class="cta-content">
        <h3 class="cta-headline">Elevate Your Senses: The VIP Experience</h3>
        <p class="cta-body">
          <strong>Want to make your night unforgettable?</strong> Consider booking a private table. <br> Treat yourself to an exclusive VIP bottle service experience with prime views of the DJ, dedicated service, and a private space for your crew to enjoy the party.
        </p>
        <div class="cta-actions">
          <a :href="whatsappLink" @click="onReservationsClick('WhatsApp')" target="_blank" rel="noopener noreferrer" class="btn-sm btn-primary whatsapp">
            Inquire via WhatsApp
          </a>
          <a :href="mailLink" @click="onReservationsClick('Email')" class="cta-link-secondary">Book via Email</a>
        </div>
        <p class="cta-footer">
          Our concierge team will reply within 15 mins (9am - 11pm).
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TableReservationsCTA',
  props: {
    // Pass the event or venue name to pre-fill the message
    eventName: {
      type: String,
      default: 'Event Information'
    }
  },
  data() {
    return {
      // You can make this image a prop to customize it per page
      ctaImage: 'https://imgix.cosmicjs.com/d38e0f20-9a39-11ee-b34c-99d1d89e42eb-aqua-eye.png?w=300&h=300&fit=clamp&monochrome=a45132&auto=enhance',
      phoneNumber: '524421867547',
      email: 'bookings@tulum.party' // Base email
    };
  },
  computed: {
    whatsappLink() {
      // ✅ UPDATED: Using the standardized message format
      const message = encodeURIComponent(`INFO: ${this.eventName}\n-------\n`);
      return `https://wa.me/${this.phoneNumber}?text=${message}`;
    },
    mailLink() {
      // ✅ UPDATED: Using the dynamic "plus" address for better email filtering
      const dynamicIdentifier = this.eventName.replace(/\s/g, '-').toLowerCase();
      return `mailto:bookings+${dynamicIdentifier}@tulum.party`;
    }
  },
  methods: {
    /**
     * ✅ NEW: Added analytics and logging method.
     * This fires when a user clicks a contact link.
     * @param {string} channel - The contact method used (e.g., 'WhatsApp', 'Email').
     */
    onReservationsClick(channel) {
      // Assuming you have Google Analytics (ga) and Rollbar globally available or injected.
      if (window.ga) {
        window.ga('send', 'event', 'reservations', `CTA-${channel}`, this.eventName, 50);
      }
      if (this.$rollbar) {
        this.$rollbar.info(`RESERVATIONS_CTA: ${this.eventName} via ${channel}`);
      }
    }
  }
};
</script>

<style scoped>
.reservations-cta-container {
  padding: 2rem 0;
  font-family: Arial, sans-serif;
}

.cta-card {
  display: flex;
  background: linear-gradient(135deg, #2b2b2d, #252528);
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0,0,0,0.3);
  border: 1px solid #444;
}

.cta-image-container {
  flex: 1;
  min-width: 40%;
  background-color: #000;
}

.cta-image-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.cta-content {
  flex: 1.5;
  padding: 2.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #f0f0f0;
}

.cta-headline {
  font-family: 'Oswald', sans-serif;
  font-size: 2rem;
  font-weight: 700;
  color: #d4af37; /* Gold accent */
  margin: 0 0 1rem 0;
}

.cta-body {
  font-size: 1rem;
  line-height: 1.7;
  color: #ccc;
  margin-bottom: 2rem;
}

.cta-actions {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.cta-btn {

  font-size: 11px;
  transition: all 0.2s ease;
}



.cta-link-secondary {
  color: #aaa;
  text-decoration: underline;
  font-size: 0.9rem;
}
.cta-link-secondary:hover {
  color: #fff;
}

.cta-footer {
  margin-top: 1.5rem;
  font-size: 0.8rem;
  color: #888;
}

@media (max-width: 768px) {
  .cta-card {
    flex-direction: column;
  }
  .cta-image-container {
    height: 200px;
  }
  .cta-content {
    padding: 2rem;
    text-align: center;
  }
  .cta-actions {
    justify-content: center;
  }
}
</style>
